<template lang="pug">
div
  el-alert.margin-bottom(
      v-if="inputsExtraCadastro.georreferencia.texto"
      title="Atenção",
      type="info")
      span O Georreferenciamento deve ser da área atual

  div(v-if="!georreferenciamentoSigef")
    div.mapa
    validation-provider(rules="required", v-slot="{ errors }", name="Georreferenciamento/Geometria")
      mapa(
        v-model="localizacoes",
        :localizacoes="localizacoes"
        name="Geometria",
        idMapa="mapaCadastroGeo"
        :errors="errors"
      )
      span.help.erro {{ errors[0] }}
    div
      app-documentos(
        :maxSize='25000',
        :valid-extensions="['rar', 'zip']",
        :documentos="cadastro.georreferenciamento.documentos"
        :tiposDocumentos="documentos"
        :tiposDocumentosObrigatorios="docsNotRequired ? [] : documentos"
        :observer="observer",
        :pecasTecnicas="true",
        aba="Georreferenciamento"
      )

  div(v-else)
    div(v-if="showGeorreferenciamentoOption")
      validation-provider(rules="required", v-slot="{ errors }", name="Georreferenciamento/Possui Georreferenciamento'")
        app-label(label="Possui o georreferenciamento do imóvel de acordo com as normas técnicas em vigência?")
        el-radio-group.radio-group.margin-bottom(
          data-vv-scope='georreferenciamento',
          data-vv-validate-on="change",
          data-vv-delay="10",
          name="possuiGeorrefenrenciamento",
          v-model="cadastro.georreferenciamento.possuiGeorreferenciamento",
        )
          el-radio(label='POSSUI') Sim
          el-radio(label='NAO_POSSUI') Não
        span.help.erro {{ errors[0] }}

    div.mapa(v-if="cadastro.georreferenciamento.possuiGeorreferenciamento === 'NAO_POSSUI'")
      validation-provider(rules="required", v-slot="{ errors }", name="Georreferenciamento/Geometria")
        mapa(
          v-model="localizacoes",
          :localizacoes="localizacoes"
          name="Geometria",
          idMapa="mapaCadastroGeo"
          :errors="errors"
        )
        span.help.erro {{ errors[0] }}

    div(v-if="cadastro.georreferenciamento.possuiGeorreferenciamento === 'POSSUI'")
      app-dados-responsavel(
        :responsavel="cadastro.georreferenciamento.responsavel"
        nomeAba="Georreferenciamento"
      )

      app-documentos(
        @mudaTipo="mudaTipo"
        :maxSize='25000',
        :valid-extensions="extensoes",
        :documentos="cadastro.georreferenciamento.documentos"
        :tiposDocumentos="documentos"
        :tiposDocumentosObrigatorios="docsNotRequired ? [] : documentos"
        :observer="observer",
        :pecasTecnicas="true"
        @setDadosPlanilha="setDadosPlanilha"
        aba="Georreferenciamento"
      )

</template>

<script>
import { mapActions } from 'vuex'
import { validate } from 'vee-validate'
import Mapa from '../Mapa'
import AppDocumentos from './AppDocumentos'
import AppDadosResponsavel from '@/components/AppDadosResponsavel'
import AppLabel from '@/components/AppLabel'
const {inputsExtraCadastro, georreferenciamentoSigef} = require('@/utils/' + process.env.ESTADO + '/regrasCentral').default

export default {

  components: {
    Mapa,
    AppDadosResponsavel,
    AppDocumentos,
    AppLabel
  },

  props: ['cadastro', 'observer', 'docsNotRequired', 'showGeorreferenciamentoOption'],

  async created () {
    this.documentos = await this.findDocumentos('geo')
    if (!this.georreferenciamentoSigef) {
      this.cadastro.georreferenciamento.possuiGeorreferenciamento = 'NAO_POSSUI'
    } else if (!this.showGeorreferenciamentoOption) {
      this.cadastro.georreferenciamento.possuiGeorreferenciamento = 'POSSUI'
    }
  },

  data () {
    return {
      documentos: [],
      inputsExtraCadastro,
      georreferenciamentoSigef,
      extensoes: ['pdf', 'rar', 'zip', 'ods', 'xls', 'xlsx']
    }
  },

  computed: {
    localizacoes () {
      return this.cadastro.georreferenciamento.localizacoes
    }
  },

  methods: {
    ...mapActions({
      findTiposDocumentosObrigatorios: 'documentos/findTiposDocumentosObrigatoriosGeo',
      findDocumentos: 'tipoDocumento/findTiposDocumento'
    }),

    setDadosPlanilha (valor) {
      this.cadastro.georreferenciamento.denominacao = valor.denominacao
      this.cadastro.georreferenciamento.jsonPlanilha = valor.jsonPlanilha
      this.cadastro.georreferenciamento.tipoPlanilha = valor.tipoPlanilha
    },
    mudaTipo (opcao) {
      switch (opcao.tipo) {
        case 'RELATORIO_TECNICO_DE_EXECUCAO_DO_GEOPROCESSAMENTO':
        case 'ART_TRT':
          this.extensoes = ['pdf']
          break
        case 'RELATORIO_DE_PROCESSAMENTO':
        case 'ARQUIVOS_GNSS':
          this.extensoes = ['zip']
          break
        case 'TABELA_DADOS_CARTOGRAFICOS':
          this.extensoes = ['ods', 'xlsx']
          break
      }
    }
  },

  watch: {
    async localizacoes () {
      await validate('required', {
        skipIfEmpty: false
      })

      this.observer.validate()
    }
  }

}
</script>

<style lang="scss" scoped>
  .mapa {
    height: 100%;
    margin: 10px 0 20px 0px;
  }

  .margin-bottom {
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/screens/central/components/cadastro/AppGeorreferenciamento.vue